import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { WarningModes, Timer } from "../../../../Constant";
import { AUTO_CLOSE } from "../../../../Data/Bonus Ui/SweetAlert";

const AutoCloseTimer = () => {
  const displayAlert = () => {
    SweetAlert.fire({ timer: 3000, showConfirmButton: false, title: "Auto close alert!", text: "just a wait! I will close in 3 second!", confirmButtonColor: "#33BFBF" });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={WarningModes} span={AUTO_CLOSE} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="sweet-1" type="button" onClick={displayAlert}>
            {Timer}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AutoCloseTimer;
